import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';

const TesekkurSayfasi = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const teklifKodu = new URLSearchParams(location.search).get('teklifKodu');

  useEffect(() => {
    if (!teklifKodu) {
      navigate('/');
    }
  }, [teklifKodu, navigate]);

  // Google Ads dönüşüm takibi için yeni useEffect
  useEffect(() => {
    if (teklifKodu && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-948144939/XJWpCM6It5EDEKuWjsQD'
      });
    }
  }, [teklifKodu]);

  if (!teklifKodu) return null;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <Helmet>
        <title>Teşekkürler | SigortamOlsun</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="max-w-lg w-full text-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6 animate-fade-in">
          {/* Başarı İkonu */}
          <div className="flex justify-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <svg 
                className="w-10 h-10 text-green-500" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
          </div>

          {/* Teşekkür Mesajı */}
          <h1 className="text-2xl font-bold text-gray-800">
            Teşekkürler!
          </h1>

          {/* Teklif Kodu */}
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-blue-800 font-medium">
              Teklif Kodunuz: {teklifKodu}
            </p>
          </div>

          {/* Bilgilendirme Mesajları - Aynı boyutta */}
          <div className="space-y-2">
            <p className="text-lg text-gray-600">
              En kısa sürede sigorta uzmanımız size dönüş yapacak!
            </p>
            <p className="text-lg text-gray-600">
              İhtiyacın olduğu anda sigortamolsun.com yanında.
            </p>
          </div>

          {/* Tamamlayıcı Sağlık Sigortası Bilgilendirmesi */}
          <div className="mt-8 bg-blue-50 p-6 rounded-lg space-y-4">
            <h2 className="text-lg font-semibold text-blue-900">
              Biliyor muydunuz?
            </h2>
            <p className="text-gray-700">
              Tamamlayıcı Sağlık Sigortası ile özel hastanelerde ücretsiz tedavi olabilirsiniz. Yeni yıl indirimlerini kaçırmamak için hemen teklif alın.
            </p>
            <button
              onClick={() => navigate('/tamamlayici-saglik-sigortasi')}
              className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200"
            >
              Teklif Al
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TesekkurSayfasi;